export var MOSTRAR_IMAGEN_USUARIO = 'MOSTRAR_IMAGEN_USUARIO';
export var mostrarImagenUsuario = function mostrarImagenUsuario() {
  return {
    type: MOSTRAR_IMAGEN_USUARIO
  };
};
export var OCULTAR_IMAGEN_USUARIO = 'OCULTAR_IMAGEN_USUARIO';
export var ocultarImagenUsuario = function ocultarImagenUsuario() {
  return {
    type: OCULTAR_IMAGEN_USUARIO
  };
}; // export const ACTIVAR_EDITOR_PIZARRA = 'ACTIVAR_EDITOR_PIZARRA'
// export const activarEditorPizarra = () => ({type: ACTIVAR_EDITOR_PIZARRA })
// export const DESACTIVAR_EDITOR_PIZARRA = 'DESACTIVAR_EDITOR_PIZARRA'
// export const desactivarEditorPizarra = () => ({type: DESACTIVAR_EDITOR_PIZARRA })